import React from 'react';

import { UserAvatar } from '../UserAvatar';
import { UserLink } from '../UserLink';

import {
  UserAvatarLinkLinkType,
  UserAvatarLinkUser
} from './UserAvatarLink.types';

interface UserAvatarLinkDefaultProps {
  user: UserAvatarLinkUser;
  linkType?: UserAvatarLinkLinkType;
}

interface UserAvatarLinkWithClassNameProps {
  className: string;
  avatarType?: never;
  width?: number;
  height?: number;
}

interface UserAvatarLinkWithAvatarTypeProps {
  className?: never;
  avatarType: 'main' | 'xl' | 'xs' | 's';
  width?: number;
  height?: number;
}

type UserAvatarLinkProps = UserAvatarLinkDefaultProps &
  (UserAvatarLinkWithClassNameProps | UserAvatarLinkWithAvatarTypeProps);

function UserAvatarLink({
  className,
  avatarType,
  user,
  linkType,
  width,
  height
}: UserAvatarLinkProps) {
  if (!user) {
    return null;
  }

  return (
    <UserLink user={user} className="h-fit w-fit" linkType={linkType}>
      <UserAvatar
        className={className}
        type={avatarType}
        user={user}
        width={width}
        height={height}
      />
    </UserLink>
  );
}

export default UserAvatarLink;
